import { engineComponent, StringUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";
import { PlayList } from "../Components/Sounds/PlayList";

@engineComponent(ComponentTypes.DisplayObject)
export class SoundElement extends BaseElement {
    private soundName: string = null;

    private _loop: boolean = false;
    private _reset: boolean = false;

    private _playing: boolean = false;
    private _scheduledPlay: boolean = false;
    private _scheduledStop: boolean = false;

    private _fadeInTime: number = 0;
    private _fadeOutTime: number = 0;

    private _timer: FrameTimerEventEmitter;

    constructor() {
        super();
        this._timer = CreateFrameTimer("TimelineElement");
    }

    public createByNode(node: Element): void {
        super.createByNode(node);
    }

    /**
     * @param node
     */
    public updateByNode(node: Element): void {
        if (!node) {
            this.logError("No node specified for element update!");
            return;
        }

        if (DEBUG) {
            if (
                node.hasAttribute(SoundElementAttributes.DEBUG) &&
                node.getAttribute(SoundElementAttributes.DEBUG) === "true"
            ) {
                debugger;
            }
        }

        if (node.hasAttribute(SoundElementAttributes.LOOP)) {
            // this._loop = StringUtils.parseBoolean(node.getAttribute(SoundElementAttributes.LOOP));

            let value: string = node.getAttribute(SoundElementAttributes.LOOP);
            let intValue: number = parseInt(value);
            this._loop = true;
            if (value === "true") {
                this.schedulePlay(0);
            } else if (!isNaN(intValue)) {
                this.schedulePlay(intValue);
            }
        }

        if (node.hasAttribute(SoundElementAttributes.RESET)) {
            this._reset = StringUtils.parseBoolean(node.getAttribute(SoundElementAttributes.RESET));
        }

        if (node.hasAttribute(SoundElementAttributes.FADE_IN)) {
            this._fadeInTime = parseInt(node.getAttribute(SoundElementAttributes.FADE_IN));
        }

        if (node.hasAttribute(SoundElementAttributes.FADE_OUT)) {
            this._fadeOutTime = parseInt(node.getAttribute(SoundElementAttributes.FADE_OUT));
        }

        if (node.hasAttribute(SoundElementAttributes.NAME)) {
            let newName: string = node.getAttribute(SoundElementAttributes.NAME);
            if (this.soundName != newName) {
                this.stop();
                this.soundName = node.getAttribute(SoundElementAttributes.NAME);
            }
        }

        if (node.hasAttribute(SoundElementAttributes.STOP)) {
            let value: string = node.getAttribute(SoundElementAttributes.STOP);
            let intValue: number = parseInt(value);
            if (value === "true") {
                this.scheduleStop(0);
            } else if (!isNaN(intValue)) {
                this.scheduleStop(intValue);
            }
        }

        if (node.hasAttribute(SoundElementAttributes.PLAY)) {
            let value: string = node.getAttribute(SoundElementAttributes.PLAY);
            let intValue: number = parseInt(value);
            if (value === "true") {
                this.schedulePlay(0);
            } else if (!isNaN(intValue)) {
                this.schedulePlay(intValue);
            }
        }
    }

    protected internalDestroy(options?: PIXI.DestroyOptions | boolean): void {}

    public clone(): any {
        let element = new SoundElement();
        element.soundName = this.soundName;
        element._fadeInTime = this._fadeInTime;
        element._fadeOutTime = this._fadeOutTime;
        element._loop = this._loop;
        element._reset = this._reset;
        element._playing = this._playing;
        element._scheduledPlay = this._scheduledPlay;
        element._scheduledStop = this._scheduledStop;

        element.markAsCloned();
        return element;
    }

    private schedulePlay(delay: number = 0): void {
        this._timer.stop();
        this._timer.removeAllListeners();
        if (delay > 0) {
            this._scheduledPlay = true;
            this._timer.once(FrameTimerEvents.Complete, this.play.bind(this));
            this._timer.start(delay);
        } else {
            this.play();
        }
    }

    private scheduleStop(delay: number = 0): void {
        this._timer.stop();
        this._timer.removeAllListeners();
        if (delay > 0) {
            this._scheduledStop = true;
            this._timer.once(FrameTimerEvents.Complete, this.stop.bind(this));
            this._timer.start(delay);
        } else {
            this.stop();
        }
    }

    private play(): void {
        if (this.soundName == null) {
            return;
        }
        if (this._playing) {
            if (this._reset) {
                this.stop();
            } else {
                return;
            }
        }
        this._timer.stop();
        this._timer.removeAllListeners();
        this._playing = true;
        this._scheduledPlay = false;
        if (this._loop) {
            PlayList.loop(this.soundName, this._fadeInTime, this._reset);
        } else {
            PlayList.play(this.soundName, this._fadeInTime, this._reset);
        }
    }

    private stop(): void {
        if (this.soundName == null) {
            return;
        }
        if (this._playing) {
            this._timer.stop();
            this._timer.removeAllListeners();
            PlayList.stop(this.soundName, this._fadeOutTime);
            if (this._fadeOutTime) {
                this._timer.once(FrameTimerEvents.Complete, this.reset.bind(this));
                this._timer.start(this._fadeOutTime);
            } else {
                this.reset();
            }
        }
    }

    private reset(): void {
        this._timer.stop();
        this._timer.removeAllListeners();
        this._playing = false;
        this._scheduledPlay = false;
        this._scheduledStop = false;
        if (this.soundName && PlayList.isPlaying(this.soundName)) {
            PlayList.stop(this.soundName);
        }
    }
}

export const SoundElementAttributes = {
    DEBUG: "Debug",

    NAME: "Name",
    LOOP: "Loop",
    RESET: "Reset",
    FADE_IN: "FadeIn",
    FADE_OUT: "FadeOut",
    PLAY: "Play",
    STOP: "Stop",
};



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/SoundElement.ts
 **/